<fuse-card class="flex h-full flex-col">
  <div class="flex items-center gap-2 border-b px-4 py-3">
    <span class="flex-1 text-base font-semibold text-gray-900">My Action Items</span>
    @if (totalCount) {
      <span class="rounded-full px-2 py-0.5 text-sm font-bold" [ngClass]="totalCount | countBadgeRing">{{ totalCount }}</span>
    }
  </div>
  @if (loading) {
    <div class="flex flex-1 items-center justify-center">
      <mat-spinner diameter="28" color="primary"></mat-spinner>
    </div>
  }
  @if (!loading && todos.length) {
    <div class="flex-1 overflow-y-auto">
      @for (todo of todos; track $index) {
        <div class="flex items-center gap-3 border-b px-4 py-1 last:border-b-0" [matTooltip]="todo.tooltip ?? ''" matTooltipPosition="above">
          <div
            class="h-2 w-2 shrink-0 rounded-full"
            [class.bg-red-500]="todo.alert === 'danger'"
            [class.bg-amber-500]="todo.alert === 'warning'"
            [class.bg-blue-500]="todo.alert === 'info'"
            [class.bg-green-500]="todo.alert === 'success'"
          ></div>
          <span class="flex-1 text-sm leading-snug text-gray-700" [innerHTML]="todo.message"></span>
          <span [class]="'shrink-0 rounded-full px-2.5 py-0.5 text-xs font-semibold ' + (todo.alert | badge)">{{ todo.alert | alertLabel }}</span>
          @if (todo.route) {
            <a role="button" (click)="navigate(todo)" class="shrink-0 cursor-pointer text-xs font-medium text-primary hover:underline">View</a>
          }
        </div>
      }
    </div>
  }
  @if (!loading && error) {
    <div class="flex flex-1 flex-col items-center justify-center gap-2 text-red-400">
      <mat-icon fontIcon="error_outline" class="opacity-60 icon-size-8"></mat-icon>
      <span class="text-sm font-medium">{{ error }}</span>
    </div>
  }
  @if (!loading && !error && !todos.length) {
    <div class="flex flex-1 flex-col items-center justify-center gap-2 text-gray-400">
      <mat-icon fontIcon="check_circle_outline" class="opacity-40 icon-size-8"></mat-icon>
      <span class="text-sm font-medium">No action items</span>
    </div>
  }
</fuse-card>
